// Module
var code = "<a class=\"vertical-center be-indicator ml-5\" href=\"{{ $ctrl.url }}\" target=\"_blank\" rel=\"noopener\" ng-if=\"$ctrl.limitedToBE\">\r\n  <ng-transclude></ng-transclude>\r\n  <pr-icon icon=\"'briefcase'\" class-name=\"'space-right be-indicator-icon'\"></pr-icon>\r\n  <span class=\"be-indicator-label\">Business Feature</span>\r\n</a>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/BEFeatureIndicator/BEFeatureIndicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;